import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './common/header/header.component';
import { RulesComponent } from './rules.component';
import {ROUTED_COMPONENT, RulesRoutingModule} from './rules.routing.module';
import {SharedModule} from '../shared/shared.module';
import { RulesListComponent } from './rules-list/rules-list.component';
import { RuleRowComponent } from './rules-list/rule-row/rule-row.component';
import { RuleStatisticsComponent } from './rules-list/rule-statistics/rule-statistics.component';
import { RuleTableComponent } from './rules-list/rule-table/rule-table.component';
import { RuleDetailsComponent } from './rule-details/rule-details.component';
import { NewRuleComponent } from './new-rule/new-rule.component';
import { RuleBuilderComponent } from './new-rule/rule-builder/rule-builder.component';
import { SelectChannelsComponent } from './new-rule/select-channels/select-channels.component';
import { SaveRuleComponent } from './new-rule/save-rule/save-rule.component';
import { SetupActionComponent } from './new-rule/setup-action/setup-action.component';
import {AppTranslateModule} from '../core/translate/translate.module';
import { SetConditionComponent } from './new-rule/set-condition/set-condition.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ConditionComponent } from './new-rule/condition/condition.component';
import { ConditionRowComponent } from './new-rule/condition-row/condition-row.component';
import {ConditionColComponent} from './new-rule/condition-col/condition-col.component';
import {RulesService} from './rules.service';
import { OperatorFilterPipe } from './pipes/operator-filter.pipe';
import { ThingNamePipe } from './pipes/thing-name.pipe';
import {ConfirmPopoverModule} from '../shared/confirmpopover/confirm.pop.module';
import { LogicalOperatorPipe } from './pipes/logical-operator.pipe';
import {ChannelService} from './channel.service';
import { MailComponent } from './output/mail/mail.component';
import { MailAddressComponent } from './output/mail/mail-address/mail-address.component';
import {OperatorTranslatePipe} from './pipes/operator-translate.pipe';
import { MailPreviewComponent } from './output/mail/mail-preview/mail-preview.component';
import {RuleEditGuard} from './guards/rule-edit-guard.guard';
import { RulePreviewComponent } from './common/rule-preview/rule-preview.component';
import { ToAttributeNamePipe } from './pipes/to-attribute-name.pipe';
import {SetConditionOption} from './model/Set-condition.option.service';
import { ThingSelectorDirective } from './directives/thing-selector.directive';;
import {MentionListComponent} from './common/mention-list/mention-list-component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RulesRoutingModule,
    AppTranslateModule,
    ReactiveFormsModule,
    FormsModule,
    ConfirmPopoverModule,
  ],
  declarations: [HeaderComponent, RulesComponent , ROUTED_COMPONENT,
    RulesListComponent, RuleRowComponent, RuleStatisticsComponent, RuleTableComponent,
    RuleDetailsComponent, NewRuleComponent, RuleBuilderComponent, SelectChannelsComponent,
    SaveRuleComponent, SetupActionComponent, SetConditionComponent, ConditionComponent,
    ConditionRowComponent, ConditionColComponent, OperatorFilterPipe, ThingNamePipe, LogicalOperatorPipe,
    MailComponent,
    MailAddressComponent,
    OperatorTranslatePipe,
    MailPreviewComponent,
    RulePreviewComponent,
    ToAttributeNamePipe,
    ThingSelectorDirective,
    MentionListComponent],
  providers: [RulesService, ChannelService, RuleEditGuard, SetConditionOption],
  entryComponents: [
    SetConditionComponent,
    MentionListComponent
  ]
})
export class RulesModule { }



// WEBPACK FOOTER //
// ./src/app/rules/rules.module.ts